/*@ngInject*/
export default (function () { return function (items, find) {
    return items.filter(function (item) {
        return !find ? true : item.prefix.match(find)
            || item.type.match(new RegExp(find, "i"))
            || item.city.match(new RegExp(find, "i"));
    });
}; });
//# sourceMappingURL=order.number.filter.js.map